import { render } from "./IndexProject.vue?vue&type=template&id=638f39b1"
import script from "./IndexProject.vue?vue&type=script&lang=js"
export * from "./IndexProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__